import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinoreUguale = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 18" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-18",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsx("path", {
				d: "M598.888889,596.111111 L598.888889,555.611111 L426.888889,480.111111 L426.888889,476.611111 L598.888889,401.111111 L598.888889,361.111111 L388.888889,456.111111 L388.888889,500.611111 L598.888889,596.111111 Z M598.888889,656.611111 L598.888889,622.611111 L388.888889,622.611111 L388.888889,656.611111 L598.888889,656.611111 Z",
				id: "\\u2264",
				fill: "#424548",
				fillRule: "nonzero"
			})]
		})
	})]
});
export default SvgMinoreUguale;
